import type { MonthStats } from '../lib/monthStats';

/**
 * 상태 범례 + 이번 달 통계 바 (목업 `.cal-legend`).
 *
 * 달력 카드 안이 아니라 툴바와 달력 사이의 독립 카드다 — 월간/주간 어느 뷰를 그리든 같은
 * 자리에 한 번만 서고, 통계가 필터 적용 후 데이터를 말하려면 달력 컴포넌트보다 위에 있어야 한다.
 * 스와치 색(400)은 셀 이벤트 pill(`EVENT_PILL_CLASS` — 연배경 100 + 글자 700)의 두 명도를
 * 한 색으로 대변한다(시안 페어링). 상태→색 대응을 한쪽만 바꾸면 범례가 조용히 거짓말을 한다.
 */
export default function CalendarLegend({ stats }: { stats?: MonthStats | null }) {
  return (
    <div className="flex flex-wrap items-center gap-x-[22px] gap-y-2 rounded-[14px] border border-line bg-white px-[18px] py-[11px] shadow-card-sm">
      <span className="inline-flex items-center gap-2 text-[13.5px] font-semibold text-ink-600">
        <span className="h-2.5 w-2.5 flex-none rounded-[3px] bg-violet-400" />
        예약됨
      </span>
      <span className="inline-flex items-center gap-2 text-[13.5px] font-semibold text-ink-600">
        <span className="h-2.5 w-2.5 flex-none rounded-[3px] bg-blue-400" />
        진행 중
      </span>
      <span className="inline-flex items-center gap-2 text-[13.5px] font-semibold text-ink-600">
        <span className="h-2.5 w-2.5 flex-none rounded-[3px] bg-emerald-400" />
        완료
      </span>
      {/* 변경 요청만 원형 — 셀의 표시가 상태 바가 아니라 우상단 점(ring 원형 마커)이라
          스와치도 점이어야 실물을 말한다. 시안은 넷 다 사각이지만 실물 우선. */}
      <span className="inline-flex items-center gap-2 text-[13.5px] font-semibold text-ink-600">
        <span className="h-2 w-2 flex-none rounded-full bg-amber-400 ring-2 ring-amber-400/25" />
        변경 요청
      </span>

      {stats && (
        <div className="ml-auto flex flex-wrap gap-x-[18px] gap-y-1 text-[12.5px] font-semibold text-ink-500">
          <span className="whitespace-nowrap">
            이번 달 점검: <b className="font-bold tabular-nums text-ink-800">{stats.total}</b>건
          </span>
          <span className="whitespace-nowrap">
            진행 중: <b className="font-bold tabular-nums text-ink-800">{stats.inProgress}</b>건
          </span>
          <span className="whitespace-nowrap">
            완료: <b className="font-bold tabular-nums text-ink-800">{stats.completed}</b>건
          </span>
          <span className="whitespace-nowrap">
            변경 요청: <b className="font-bold tabular-nums text-ink-800">{stats.pendingRequests}</b>건
          </span>
        </div>
      )}
    </div>
  );
}
